import React from "react";

interface StarIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const StarIcon: React.FC<StarIconProps> = ({ className = "", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className={className} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00039 1.3999C7.2428 1.3999 7.45957 1.55083 7.5437 1.77817L8.34188 3.93521C8.63729 4.73356 9.26674 5.363 10.0651 5.65842L12.2221 6.4566C12.4495 6.54072 12.6004 6.7575 12.6004 6.9999C12.6004 7.24231 12.4495 7.45909 12.2221 7.54321L10.0651 8.34139C9.26674 8.6368 8.63729 9.26625 8.34188 10.0646L7.5437 12.2216C7.45957 12.449 7.2428 12.5999 7.00039 12.5999C6.75798 12.5999 6.54121 12.449 6.45708 12.2216L5.65891 10.0646C5.36349 9.26625 4.73405 8.6368 3.9357 8.34139L1.77866 7.54321C1.55132 7.45909 1.40039 7.24231 1.40039 6.9999C1.40039 6.7575 1.55132 6.54072 1.77866 6.4566L3.9357 5.65842C4.73404 5.363 5.36349 4.73356 5.65891 3.93521L6.45708 1.77817C6.54121 1.55083 6.75798 1.3999 7.00039 1.3999Z"
        fill="currentColor"
      />
    </svg>
  );
};
